import React from 'react';

const Quote = () => {
    return(
        <>
        {/*Get A Quote Section*/}
        <section className="get-quote-section section-padding-two">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-8 text-white">
                <h4> SUBSCRIBE TO OUR NEWSLETTER! </h4>
                <span>Never Miss Anything From Construx By Signing Up To Our Newsletter.</span>
                </div>
                <div className="col-lg-4">
                <form role="search" method="post" action="#">
                    <div className="input-group">
                    <input name="news-letter" className="form-control" placeholder="Enter Your Email" type="text" />
                    <span className="input-group-btn">
                        <button type="submit" className="site-button"><i className="fa fa-paper-plane-o" /></button>
                    </span>
                    </div>
                </form>
                </div>
            </div>
            </div>
        </section>
        {/*End Get A Quote Section*/}
        </>
    )
}

export default Quote;